import { registerWC } from '@utils/registerWebComponent'

type FoodiOrderCheckoutProps = {
  offerId: string
  // Lets the MFE fetch offers itself when its store is cold (deep link /
  // refresh) — the offerBuilders query requires the holding.
  holdingId?: string
  // Non-`on` name: reactify-wc would route an on* prop to addEventListener,
  // so the callback must use a verb name to reach the MFE as a property.
  goBack: () => void
}

// Same bundle as foodi-commander (it registers all three custom elements).
export const FoodiOrderCheckout = registerWC<FoodiOrderCheckoutProps>(
  'foodi-order-checkout',
  '/mfe/commander'
)
